export const env = {
ENABLE_INVESTING_ACCOUNT_CONTROLLER: "true",
ENABLE_TAX_DECLARATION_CONTROLLER: "true",
ENABLE_REFERRAL_CONTROLLER: "true",
ENABLE_PROFILE: "true",
ENABLE_OSA_WIKI: "true",
ENABLE_MILITARY_TAX: "true",
ENABLE_OTHER_INCOMES: "false",
ENABLE_UNIFIED_UPLOAD: "true",
ENABLE_SYNC_UNIT_CONTROLLER: "true",
ENABLE_TAX_PLANNER_CONTROLLER: "true",
TAX_REPORTS: "['details', 'f1']",
KEYCLOAK_HOST: "https://auth.stg.osa.tax/realms/osatax-stg_UA",
KEYCLOAK_CLIENT_ID: "oauth2-pkce-client",
BACKEND_HOST: "https://back.stg.osa.tax",
BANK: "MONOBANK",
LANGUAGE: "ua",
GOOGLE_FORM_URL: "https://docs.google.com/forms/d/e/1FAIpQLSdWWXZ5yrrOmiCal3QLFrdO3x_enfTwTL_cNXx41LRf9S64sw/viewform",
MAIN_PAGE_VIDEO_URL: "https://www.youtube.com/embed/T5iGDLLsl_s",
DECLARATION_PAGE_VIDEO_URL_ID: "zLnbdmuAing",
}
